import { _ as _define_property } from "@swc/helpers/_/_define_property";
export class TeamInviteModel {
    static fromDTO(dto) {
        return new TeamInviteModel(dto);
    }
    inviteId() {
        return this.data.inviteId;
    }
    businessId() {
        return this.data.businessId;
    }
    businessName() {
        return this.data.businessName;
    }
    isServiceProvider() {
        return this.data.isServiceProvider;
    }
    constructor(data){
        _define_property(this, "data", void 0);
        this.data = data;
    }
}
